import { useTranslation } from 'react-i18next';
import { LiliAutoComplete, Text, FontWeight } from '@lili/lili-frontend-common';
import { useMemo } from 'react';
import { EddEmbeddedFields } from '@Pages/happyFlowPages/eddQuestions/pages/embedded/fields.types';
import { ControllerWrapper } from '@Hooks/index';

export const NonprofitDescriptionEForm = () => {
  const { t } = useTranslation('eddQuestions');

  // Generate years from current year down to 1900
  const yearOptions = useMemo(() => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = currentYear; year >= 1900; year--) {
      years.push({
        title: year.toString(),
        value: year.toString(),
      });
    }
    return years;
  }, []);

  return (
    <div className='flex flex-col gap-[8px] mt-[16px]'>
      <Text.H9>{t('organic.nonprofitDescriptionE.question')}</Text.H9>

      <ControllerWrapper name={EddEmbeddedFields.EDD_NONPROFIT_DESCRIPTION_E}>
        {({ onChange, value, error }) => {
          const selectedItemValue = value ? { title: value, value: value } : null;

          return (
            <div className='flex flex-col'>
              <LiliAutoComplete
                placeholder={t('organic.nonprofitDescriptionE.placeholder')}
                onItemSelection={(item) => {
                  onChange(item.value);
                }}
                selectedItem={selectedItemValue}
                autoCompleteItems={yearOptions}
              />
              {error && (
                <Text.H10 className='text-text-negative-red text-sm mt-[8px]'>
                  {error.message}
                </Text.H10>
              )}
              <Text.H10 fontWeight={FontWeight.MEDIUM} className='text-text-main-tertiary mt-[6px]'>
                {t('organic.nonprofitDescriptionE.subtitle')}
              </Text.H10>
            </div>
          );
        }}
      </ControllerWrapper>
    </div>
  );
};
